import React from 'react'
import { Gem } from 'lucide-react'

/**
 * Компонент карточки скина для апгрейдера
 * @param {Object} skin - Объект скина с полями id, img, name, price
 * @param {boolean} isSelected - Выбрана ли карточка
 * @param {Function} onClick - Обработчик клика
 * @param {boolean} showPrice - Показывать ли цену (по умолчанию true)
 * @param {boolean} isNew - Показывать ли бейдж "New" (по умолчанию false)
 */
const UpgraderSkinCard = ({ skin, isSelected = false, onClick, showPrice = true, isNew = false }) => {
  return (
    <button
      onClick={onClick}
      className={`w-[calc((100%-0.75rem*2)/3)] max-w-[160px] bg-surface rounded-lg p-3 border-2 transition-all relative lg:w-[calc((100%-0.75rem*5)/6)] lg:max-w-none ${
        isSelected
          ? 'border-accent-primary shadow-lg shadow-accent-primary/30'
          : 'border-white/10 hover:border-accent-primary/50'
      }`}
    >
      {/* Бейдж "New" для самого свежего скина */}
      {isNew && (
        <div className="absolute top-2 right-2 z-10">
          <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-primary/20 text-accent-primary border border-accent-primary/30">
            New
          </span>
        </div>
      )}
      
      <div className="aspect-square rounded mb-2 overflow-hidden">
        <img 
          src={skin.img} 
          alt={skin.name}
          className="w-full h-full object-contain p-0"
        />
      </div>
      
      <h4 className="text-xs font-medium text-center leading-tight mb-1">
        {skin.name.includes('|') ? (
          <>
            <div className="text-white truncate">
              {skin.name.split('|')[0].trim()}
            </div>
            <div className="text-text-secondary text-[10px] truncate">
              {skin.name.split('|')[1].trim()}
            </div>
          </>
        ) : (
          <div className="text-white truncate">
            {skin.name}
          </div>
        )}
      </h4>
      
      {showPrice && (
        <div className="flex items-center justify-center gap-1">
          <Gem size={14} className="text-accent-primary" />
          <p className="text-accent-primary font-bold text-sm">
            {skin.price.toLocaleString()}
          </p>
        </div>
      )}
    </button>
  )
}

export default UpgraderSkinCard
